import { OrganizationApi } from 'apiConnector/organization';
import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics/tabRemoved';
import { SalesBeneficiary } from 'models/forms/SalesBeneficiary';
import { Item } from 'models/IItem';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import {
  addonSalesBeneficiariesReloaded,
  addonSalesBeneficiariesReloadFailed,
  addonSalesDesksReloaded,
  addonSalesDesksReloadFailed,
} from 'state/addonForm/addonForm.action';
import * as actionTypes from 'state/addonForm/addonForm.actionTypes';
import type { EpicWithThunk } from 'state/state.common';

export interface FetchAvailableSalesActors {
  fetchAvailableSalesDesks(rtfeLogin: string): Observable<Item<number>[]>;
  fetchAvailableSalesBeneficiaries(salesDesk: number): Observable<Item<SalesBeneficiary>[]>;
}

// TODO: Unit test
export function fetchAddonSalesDesksEpic(timeoutInMillis = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType(actionTypes.ADDON_SALES_BENEFICIARIES_CHANGED),
      mergeMap(({ tabId, salesBeneficiary }) => {
        if (salesBeneficiary === null) {
          return of(addonSalesDesksReloaded(tabId, []));
        }
        const tabRemoved$ = tabRemoved(actions$, tabId, state$);
        return OrganizationApi(httpClient)
          .fetchAvailableSalesDesks(salesBeneficiary)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(SalesDesks => of(addonSalesDesksReloaded(tabId, SalesDesks))),
            catchError(() => of(addonSalesDesksReloadFailed(tabId, 'could not retrieve SalesDesks'))),
            timeoutWith(timeoutInMillis, of(addonSalesDesksReloadFailed(tabId, 'TIMEOUT')), appScheduler),
          );
      }),
    );
}

// TODO: Unit test
export function fetchAddonSalesBeneficiariesEpic(timeoutInMillis = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType(actionTypes.ADDON_SALES_DESK_CHANGED),
      mergeMap(({ tabId, salesDesk }) => {
        if (salesDesk === null) {
          return of(addonSalesBeneficiariesReloaded(tabId, []));
        }
        const tabRemoved$ = tabRemoved(actions$, tabId, state$);
        return OrganizationApi(httpClient)
          .fetchAvailableSalesBeneficiaries(salesDesk)
          .pipe(
            takeUntil(tabRemoved$),
            mergeMap(SalesBeneficiaries => of(addonSalesBeneficiariesReloaded(tabId, SalesBeneficiaries))),
            catchError(() => of(addonSalesBeneficiariesReloadFailed(tabId, 'could not retrieve SalesBeneficiaries'))),
            timeoutWith(timeoutInMillis, of(addonSalesBeneficiariesReloadFailed(tabId, 'TIMEOUT')), appScheduler),
          );
      }),
    );
}
